import { useContext } from 'react';
import { useState } from 'react';
import { getExchangeRate } from '../../../api/exchange';
import { AuthContext } from '../../../context/AuthContext';

export const useFCurrencyExchange = () => {

    const [fromCurrency, setFromCurrency] = useState([
        {
            id: "484",
            value: "Pesos",
            ico: require("../../../components/assets/images/MX.png"),
        },
        {
            id: "840",
            value: "Dólares",
            ico: require("../../../components/assets/images/US.png"),
        },
    ]);

    const [toCurrency, setToCurrency] = useState([
        {
            id: "484",
            value: "Pesos",
            ico: require("../../../components/assets/images/MX.png"),
        }
    ]);


    const [fromCurrencyValue, setFromCurrencyValue] = useState("1");
    const [toCurrencyValue, setToCurrencyValue] = useState("0");
    const [originCurrencyId, setOriginCurrencyId] = useState("840");
    const [destinationCurrencyId, setDestinationCurrencyId] = useState("484");
    const [exchangeRate, setExchangeRate] = useState({});
    const [capturedAmount, setcapturedAmount] = useState(0);
    const [exchangeAmount, setExchangeAmount] = useState(0);


    const {checkToken} = useContext(AuthContext);

    const getExchange = async (originCurrencyId, destinationCurrencyId) => {
        checkToken()
        try {
            let exchangeRate = await getExchangeRate(originCurrencyId, destinationCurrencyId);
            //console.log(exchangeRate)
            exchangeRate = exchangeRate.data.data[0];
            ////console.log(exchangeRate.exchangeRate);
            setExchangeRate(exchangeRate)
            let exchange = exchangeRate.exchangeRate * parseFloat(capturedAmount);
            exchange = exchange.toString();
            //console.log(capturedAmount);
            //console.log(exchange)
            setExchangeAmount(exchangeAmount)
            return true;
        } catch (error) {
            setExchangeRate({})
        }
    }

    const setAmount = async (data) => {
        let value = parseFloat(data) || .0;
        let exchange = exchangeRate.exchangeRate * value;
        value = value.toString()
        setcapturedAmount(value)
        setExchangeAmount(exchange.toString())
    }

    function maskMoney(value) {
        const valueAsNumber = value.replace(/\D+/g, "");
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(valueAsNumber / 100);
    }


    const changeSelectItem = async (fromCurrencyId, toCurrencyId, data, setCurrency) => {
        if (fromCurrencyId != undefined && toCurrencyId != undefined) {
            checkToken()
            try {

                await setCurrency(toCurrencyId);

            } catch (error) {
                ////console.log(error);
            }

        } else {

        }

    }



    return {
        fromCurrency,
        toCurrency,
        originCurrencyId,
        destinationCurrencyId,
        exchangeRate,
        exchangeAmount,
        capturedAmount,
        setFromCurrency,
        setToCurrency,
        setOriginCurrencyId,
        setDestinationCurrencyId,
        setExchangeRate,
        setExchangeAmount,
        getExchange,
        setAmount,
        changeSelectItem,
        setcapturedAmount,
        setFromCurrencyValue,
        setToCurrencyValue,
        fromCurrencyValue,
        toCurrencyValue
    }

}